import { Component } from '@angular/core';
import { VaBasePricingComponent } from '../base-pricing.component';

@Component({
  selector: 'store-table-pricing',
  templateUrl: './table-pricing.component.html',
  styleUrls: ['./table-pricing.component.scss'],
  standalone: false,
})
export class TablePricingComponent extends VaBasePricingComponent {}
